

const CHAT_PRODUCT_MESSAGE = "Hello, I need additional information about this product.";

const CHAT_COMPANY_MESSAGE = "Hello, I would like to know more about your company and products.";

export {
    CHAT_PRODUCT_MESSAGE,
    CHAT_COMPANY_MESSAGE
};